import { createSlice } from "@reduxjs/toolkit";
import defaultTestRunColumnVisible from "./DefaultFields/testrun.json";
import defaultTestCaseColumnVisible from "./DefaultFields/testcase.json";
import defaultTestCaseDetailColumnVisible from "./DefaultFields/testcasedetail.json";
import defaultProjectListColumnVisible from "./DefaultFields/projectlist.json";
import defaultGenrateAITestCaseColumnVisible from "./DefaultFields/genrateAITestCase.json";
import defaultApprovedAITestCaseColumnVisible from "./DefaultFields/approvedAITestCase.json";
import defaultTestGroupLibraryColumnVisible from "./DefaultFields/testgrouplibrary.json";

const initialState = {
    ProjectPageView: "list",
    TestRunPageConfigure: {
        columnVisible: defaultTestRunColumnVisible || {}
    },   
    TestCasePageConfigure: {
        columnVisible: defaultTestCaseColumnVisible || {}
    },
    TestCaseDetailPageConfigure: {
        columnVisible: defaultTestCaseDetailColumnVisible || {}
    },
    GenrateAITestCasePageConfigure: {
        columnVisible: defaultGenrateAITestCaseColumnVisible || {}
    },
    ProjectListPageConfigure: {
        columnVisible: defaultProjectListColumnVisible || {}
    },
    ApprovedAITestCasePageConfigure: {
        columnVisible: defaultApprovedAITestCaseColumnVisible || {}
    },
    TestGroupLibraryPageConfigure: {
        columnVisible: defaultTestGroupLibraryColumnVisible || {}
    }
}
import { viewMap } from "../../utils/commonfunctions";


function fetchDefaultColumnVisible(page) {
    switch (page) {
        case "testrun":
            return defaultTestRunColumnVisible;
        case "testcase":
            return defaultTestCaseColumnVisible;
        case "projectlist":
            return defaultProjectListColumnVisible; 
        case "testcasedetail":
            return defaultTestCaseDetailColumnVisible;
        case "genrateAITestCase":
            return defaultGenrateAITestCaseColumnVisible;
        case "testgrouplibrary":
            return defaultTestGroupLibraryColumnVisible;
        default:
            return {};
    }
}

const userPreferenceSlice = createSlice({
    name: "userPreference",
    initialState,
    reducers: {
        updateColumnVisibility: (state, action) => {
            const { page, columnVisible=fetchDefaultColumnVisible(page) } = action?.payload || {};
            const key = viewMap[page];
            console.log(key, "key", state[key])
            state[key].columnVisible = columnVisible;
        },
        updateUserPreferences: (state, action) => {
            state = {...state, ...action?.payload};
            return state;
        },
        updatePageList: (state, action) => {
            const projectPageView = action?.payload || 'list';
            state.ProjectPageView = projectPageView;
        },
    },
});

export const { updateColumnVisibility, updateUserPreferences, updatePageList } = userPreferenceSlice.actions;
export default userPreferenceSlice.reducer;

